import React, { Component, useState } from "react";
import {connect} from "react-redux";
import ItinerarySummary from "./ItinerarySummary";
import PriceSummary from "./PriceSummary";
import * as reissueActions from "../../actions/reissueActions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationTriangle, faSearch, faSpinner} from "@fortawesome/free-solid-svg-icons";
import {Redirect} from "react-router-dom";
import Alert from "../common/Alert";
import PendingVerificationAlert from "../common/PendingVerificationAlert";
import {
    FARE_UNAVAILABLE_ACTION_LABEL,
    FARE_UNAVAILABLE_NEXT_STEP,
    FARE_UNAVAILABLE_NEXT_STEP_LABEL,
    FARE_UNAVAILABLE_REASON,
    FARE_UNAVAILABLE_REASON_LABEL,
    FARE_UNAVAILABLE_TITLE
} from "../../util/offerPriceValidation";
import Cards from "react-credit-cards";
import 'react-credit-cards/es/styles-compiled.css';
import {
    formatCreditCardNumber,
    formatCVC,
    formatExpirationDate,
    formatCardType,
    formatClearNumber
  } from '../Checkout/Payment/index';

class Checkout extends Component {

    constructor(props) {
        super(props);
        const { match, recommendationsReducer } = this.props;
        const { params } = match;
        const { recommendations } = recommendationsReducer;
        const recommendation = recommendations.find(item =>
            item.offerId?.offerId === params.offerId &&
            item.shoppingResponseRefID?.shoppingResponseRefID === params.shoppingResponseRefID
        );

        this.state = {
            recommendation,
            //fee: "",
            formOfPayment:"CASH",
            number:"",
            nameHolder:"",
            expiry:"",
            cvc:"",
            focus:"",
            issuer:"",
            itineraryDetails : {
                flightType: "",
                passengersNumber: "",
                origin: "",
                destination: "",
                itinerary: []
            },
            blockIssue: false,
            pendingVerificationLocked: false,
            fareUnavailableLocked: false
        };
    }

    // Emisión pendiente de verificación: bloquea nuevos intentos solo en esta instancia de Checkout.
    // No se persiste: al salir y volver a entrar, o al recargar, el estado se reinicia.
    getPendingVerificationLock = () => this.state.pendingVerificationLocked;

    // Tarifa no disponible: la oferta de esta instancia queda invalidada; solo una nueva búsqueda permite continuar.
    getFareUnavailableLock = () => this.state.fareUnavailableLocked;

    isReissueLocked = () => this.getPendingVerificationLock() || this.getFareUnavailableLock();

    // El aviso y el bloqueo solo se activan cuando la respuesta de la remisión actual trae el código de corte de comunicación.
    componentDidUpdate(prevProps) {
        const alert = this.props.reissueReducer.pendingVerificationAlert;
        if (alert && alert !== prevProps.reissueReducer.pendingVerificationAlert) {
            this.setState({ pendingVerificationLocked: true });
        }
        if (this.props.reissueReducer.fareUnavailable && !prevProps.reissueReducer.fareUnavailable) {
            this.setState({ fareUnavailableLocked: true });
        }
    }

    // handleCallback = ({ issuer }, isValid) => {
    //     if (isValid) {
    //       this.setState({ issuer });
    //     }
    //   };

    handleInputFocus = (e) => {
        this.setState({ focus: e.target.name });
    }
      
    handleInputChange = (e) => {
        let { name, value } = e.target;  
        if (name === "number") {
            value = formatCreditCardNumber(value);
            this.setState({ issuer : formatCardType(value)});
          } else if (name === "expiry") {
            value = formatExpirationDate(value);
          } else if (name === "cvc") {
            value = formatCVC(value);
          }      
        this.setState({ [name]: value });
     }

    componentDidMount() {
        const { recommendation } = this.state;
        this.props.resetReissue();
        if (recommendation) {
            this.props.registerCheckoutPageEvent({
                offerId: this.props.match.params.offerId,
                shoppingResponseRefID: this.props.match.params.shoppingResponseRefID
            });

            const flightType = recommendation.itinerary.lenght === 1 ? "Solo Ida" : "Ida y vuelta";
            const passengersNumber = "2";
            const origin = recommendation.itinerary[0].flights[0].departureAirport.name;
            const destination = recommendation.itinerary[0].flights[0].arrivalAirport.name;

            this.setState({
                itineraryDetails : {
                    flightType: flightType,
                    passengersNumber: passengersNumber,
                    origin: origin,
                    destination: destination,
                    itinerary: recommendation.itinerary
                }
            })
        }
    }
    onChangeInput = (e) => {
        e.preventDefault();
        const name = e.target.name;
        this.setState({
            [name]: e.target.value
        })
    };
    onReissueTicket = (e) => {
        e.preventDefault();
        if (this.isReissueLocked()) {
            return;
        }
        const { recommendation } = this.state;
        //if (recommendation.pricing.items[0].amountText.includes("-") || recommendation.pricing.items[1].amountText.includes("-")){
        //    const { pnr } = this.props;
        //    this.props.addConcurrence(pnr);
        //    this.state.blockIssue = true;
       //}else {
            const { variation } = this.props.reissueReducer;
            this.props.reissueTicket({
                currentUser: this.props.match.currentUser,
                offerId: this.props.match.params.offerId,
                shoppingResponseRefID: this.props.match.params.shoppingResponseRefID,
                formOfPayment: this.state.formOfPayment,
                paymentDetails: {
                    number: formatClearNumber(this.state.number),
                    nameHolder:this.state.nameHolder,
                    expiry: "20" + this.state.expiry.slice(2,4) + "-" + this.state.expiry.slice(0,2),
                    cvc:this.state.cvc,
                    issuer:this.state.issuer
                },
                variation
                //fee: this.state.fee
            });
        //}
    };
    onVariationOffer = (e) => {
        if (this.isReissueLocked()) {
            return;
        }
        this.props.setHasVariationOffer(true);

        const { variation } = this.props.reissueReducer;

        this.setState(prevState => ({
            recommendation: {
                ...prevState.recommendation,
                pricing: variation
            }
        }));

        this.onReissueTicket(e);
    }

    onConfirmWarningConfirmation = () => {
        if (this.isReissueLocked()) {
            return;
        }
        this.props.confirmWarningConfirmation();
    };

    onCancelWarningConfirmation = () => {
        this.props.cancelWarningConfirmation();
    };

    showActions = () => {
        if (this.state.formOfPayment === "CC") {
            return this.showPaymentCC();
        }
        const { loading } = this.props.reissueReducer;
        if (loading) {
            return this.showButtonLoading();
        }
        return (
            <div className="col">
                {this.showButtonReissueEnable()}
                {this.showBackButton()}
            </div>
        )
    };

    showButtonLoading = () => {
        return (
            <div className="col">
                <button className="btn btn-success btn-block mb-5 disabled" disabled="disabled">
                    <FontAwesomeIcon icon={faSpinner} spin/> Reemitiendo
                    reserva...
                </button>
            </div>
        )
    };

    showButtonReissueEnableOrDisable = () => {
        if (!this.state.number || !this.state.nameHolder || !this.state.expiry || !this.state.cvc) {
            return(
                <button className="btn btn-success btn-block mb-2 disabled" disabled="disabled">Reemitir </button>
            );
        } else {
            const { loading } = this.props.reissueReducer;
            if (loading) {
                return this.showButtonLoading();
            } else {
                return this.showButtonReissueEnable();
            }
        }
    };

    showButtonReissueEnable = () => {
        return (
            <button id="btnSuccess" className="btn btn-success  btn-block mb-2" disabled={this.getFareUnavailableLock()} onClick={this.onReissueTicket}> Reemitir </button>
        );
    };

    onBack = async () => {
        await this.props.registerBackEvent({
            offerId: this.props.match.params.offerId,
            shoppingResponseRefID: this.props.match.params.shoppingResponseRefID
        });
        this.props.resetReissue();
        this.props.history.goBack();
    };

    showBackButton = () => {
        return (
            <button type="button" className="btn btn-secondary btn-block mb-5" onClick={this.onBack}>Regresar</button>
        );
    };

    showMessageNotPermitIssueNegativeFare = () => {
        return (
            <div className="container-section-header">
                <h2>
                    NO SE PUEDE REMITIR TARIFAS EN NEGATIVO!
                </h2>
                <label>Por favor contacte a su supervisor para continuar con la remisión</label>
            </div>
        );
    };

    showPaymentCC = () => {

        return (
            <div className="col">
                <Cards
                    cvc={this.state.cvc}
                    expiry={this.state.expiry}
                    focused={this.state.focus}
                    name={this.state.nameHolder}
                    number={this.state.number}
                />
                <br/>
                <form>
                    <input
                        type="tel"
                        name="number"
                        value={this.state.number}
                        placeholder="Numero de tarjeta"
                        pattern="[\d| ]{16,22}"
                        required
                        onChange={this.handleInputChange}
                        onFocus={this.handleInputFocus}
                    />
                    <input
                        type="text"
                        name="nameHolder"
                        value={this.state.nameHolder}
                        placeholder="Nombre del tarjeta habiente"
                        required
                        onChange={this.handleInputChange}
                        onFocus={this.handleInputFocus}
                    />
                    <input
                        type="text"
                        name="expiry"
                        value={this.state.expiry}
                        placeholder="MM/YY Expiracion"
                        pattern="\d\d/\d\d"
                        required
                        onChange={this.handleInputChange}
                        onFocus={this.handleInputFocus}
                    />
                    <input
                        type="tel"
                        name="cvc"
                        value={this.state.cvc}
                        placeholder="CVC"
                        pattern="\d{3,4}"
                        required
                        onChange={this.handleInputChange}
                        onFocus={this.handleInputFocus}
                    />
                    <input type="hidden" name="issuer" value={this.state.issuer} />
                </form>
                <br/>
                {this.showButtonReissueEnableOrDisable()}
                {this.props.reissueReducer.loading ? null : this.showBackButton()}
            </div>
        );
    };

    goToQuotation = () => {
        window.history.back();
        setTimeout(() => {
            window.location.reload();
        }, 300);
    };

    render = () => {
        if (!this.state.recommendation) {
            return (<Redirect to='/home'/>)
        }
        const {itineraryDetails, recommendation: { pricing }} = this.state;

        const {
            success,
            errorMsg,
            errorMsgValue,
            errorType,
            hasVariationOffer,
            variation,
            hasWarningConfirmation,
            warningConfirmationMessage,
            pendingVerificationAlert
        } = this.props.reissueReducer;

        if (success) {
            return (<Redirect to='/emission'/>)
        }
        const pendingVerificationLock = this.getPendingVerificationLock();
        return (
            <div className="Home row">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="BookingProgress pt-3 pb-3">
                                <div className="row">
                                    <ul className="col">
                                        <li className="float-left font-secondary cursor-default font-light text-gray-500">
                                            1. Selecciona tu vuelo
                                            <i className="fas fa-chevron-right text-sm mr-3 ml-3">
                                                {" "}
                                            </i>
                                        </li>
                                        <li className="float-left font-secondary cursor-default font-bold text-gray-800">
                                            2. Completa tus datos
                                            <i className="fas fa-chevron-right text-sm mr-3 ml-3">
                                                {" "}
                                            </i>
                                        </li>
                                        <li className="float-left font-secondary cursor-default font-light text-gray-500">
                                            3. Finaliza la reserva
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <ItinerarySummary itineraryDetails={itineraryDetails}/>
                            <div className="FormOfPayment bg-white border mb-4">
                                <div className="pt-3 pl-3 pr-3 pb-3">
                                    <div className="row form-row">
                                        <div className="col-3">
                                            <label>Forma de Pago</label>
                                            <select className="form-control" value={this.state.formOfPayment}
                                                    name="formOfPayment" onChange={this.onChangeInput}>
                                                <option value="CASH">CASH</option>
                                                <option value="CC">TARJETA DE CREDITO</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className="col-md-4">
                            <PriceSummary pricing={pricing}/>
                            {/* < div className="row mb-4">
                                <div className="col form-items">
                                    <input type="text" className="form-control pt-2 pb-2 pl-3 pr-2 h-auto text-sm"
                                           placeholder="Ingrese Fee" value={this.state.fee} name="fee"
                                           onChange={this.onChangeInput}/>
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="col">

                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Emisión pendiente de verificación: sin acciones, solo el aviso al pie de Checkout. */}
                    { pendingVerificationLock ? (
                        pendingVerificationAlert ? <PendingVerificationAlert lock={pendingVerificationAlert}/> : null
                    ) : (
                        <div className="row">
                            {/* <div className="col"> */}
                                {this.showActions()}
                            {/* </div> */}
                        </div>
                    )}
                    { errorMsg ? <Alert message={errorMsg} messageValue={errorMsgValue} type={errorType}/> : null}
                    { this.state.blockIssue ? this.showMessageNotPermitIssueNegativeFare() : null}
                    { hasWarningConfirmation && (
                        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title mx-auto h5">Confirmación requerida</h5>
                                    </div>
                                    <div className="modal-body pt-4 pb-2 px-5">
                                        <p className="mb-3 font-weight-bold">
                                            {warningConfirmationMessage}
                                        </p>
                                        <p className="mb-4">
                                            Presione <span className="font-bold text-primary">Confirmar</span> para aceptar y continuar con la remisión, o <span className="font-bold text-muted">Cancelar</span> para cerrar este mensaje sin reenviar la solicitud.
                                        </p>
                                    </div>
                                    <div className="modal-footer">
                                        <div className="mx-auto">
                                            <button type="button" className="btn btn-primary px-4 mr-2" disabled={!!pendingVerificationLock} onClick={this.onConfirmWarningConfirmation}>
                                                Confirmar
                                            </button>
                                            <button type="button" className="btn btn-secondary" onClick={this.onCancelWarningConfirmation}>
                                                Cancelar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Tarifa no disponible: sin opción de cerrar ni de continuar con la oferta invalidada. */}
                    { this.getFareUnavailableLock() && (
                        <div className="modal fade show d-block fare-unavailable-modal" tabIndex="-1" role="dialog" aria-modal="true"
                             aria-labelledby="fareUnavailableTitle" aria-describedby="fareUnavailableReason fareUnavailableNextStep"
                             style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="fare-unavailable-header">
                                        <div className="fare-unavailable-icon" aria-hidden="true">
                                            <FontAwesomeIcon icon={faExclamationTriangle}/>
                                        </div>
                                        <h5 id="fareUnavailableTitle" className="fare-unavailable-title">{FARE_UNAVAILABLE_TITLE}</h5>
                                        <div className="fare-unavailable-reason">
                                            <p id="fareUnavailableReason" className="mb-0">{FARE_UNAVAILABLE_REASON}</p>
                                        </div>
                                    </div>
                                    <div className="fare-unavailable-body">
                                        <p className="mb-1 text-center">
                                            Presione <span className="font-bold text-muted">Volver a cotizar</span> para buscar otras opciones.
                                        </p>
                                    </div>
                                    <div className="fare-unavailable-footer">
                                        <button type="button" className="btn btn-primary fare-unavailable-action" onClick={this.goToQuotation}>
                                            <FontAwesomeIcon icon={faSearch} className="mr-2" aria-hidden="true"/>
                                            {FARE_UNAVAILABLE_ACTION_LABEL}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    { hasVariationOffer && (
                        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title mx-auto h5">Variación de tarifa</h5>
                                    </div>
                                    <div className="modal-body pt-4 pb-2 px-5">
                                        <p className="mb-2" style={{ color: '#636d7c' }}>
                                            La tarifa inicial ya no está disponible.
                                            <span className="text-dark font-normal ml-1">¿Desea proceder con la remisión utilizando la nueva tarifa?</span>
                                        </p>
                                        <p className="mb-4">
                                            Presione <span className="font-bold text-primary">Confirmar</span> para reemitir o <span className="font-bold text-muted">Volver a cotizar</span> para buscar otras opciones.
                                        </p>
                                        <PriceSummary pricing={variation}/>
                                    </div>
                                    <div className="modal-footer">
                                        <div className="mx-auto">
                                            <button type="button" className="btn btn-primary px-4 mr-2" disabled={!!pendingVerificationLock} onClick={this.onVariationOffer}>
                                                Confirmar
                                            </button>
                                            <button type="button" className="btn btn-secondary" onClick={this.goToQuotation}>
                                                Volver a cotizar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

function mapStateToProps({ recommendationsReducer, reissueReducer, transactionReducer, bookingInformationReducer }){
    return { recommendationsReducer, reissueReducer, transactionReducer, bookingInformationReducer }
}

export default connect(mapStateToProps, reissueActions)(Checkout);
